import { gql } from "@apollo/client";

const SAVE_VISITA_FIRMA = gql`
    mutation saveVisitaFirma($input: AddVisitaFirmaInput!){
        saveVisitaFirma(input: $input) {
            idVisita
        }
    }
`;

export default SAVE_VISITA_FIRMA;

export const adaptAddVisitaFirmaInput = (data, finalizada, latitud, longitud) => ({
    idVisita: data.idVisita,
    idComboVisitaValorInterlocutor: data.idComboVisitaValorInterlocutor,
    nombreCompleto: data.nombreCompleto,
    email: data.email,
    finalizada: !!finalizada,
    latitud: latitud.toString(),
    longitud: longitud.toString(),
    desdeCoordinacion: !!data?.desdeCoordinacion
});